export interface InstagramBoxConfig {
  magazineId: string;
  userId: string;
  params: {
    access_token: string;
    limit?: number;
    fields: string;
  };
}

// Todo: Pořešit získaní access_tokenu bezpečnějším způsobem

export const instagramBoxConfig: InstagramBoxConfig[] = [
  {
    magazineId: '20',
    userId: '6309589502417553',
    params: {
      access_token:
        'IGQWRPbnFidWU3THhFTGI0STFvaEhOZA0F5R0JQUm9wZA2VlWFF3QVp5TnB3czFDSmZADTmRROWt6QUt6NzBsY0t0N1llNEswV05McTI0RTdNWENlXzZAvLVpHZAnJpM0VmYlppaElFM3ZA5M2NxemJFenJabzROeDNmRmsZD',
      limit: 6,
      fields: 'id,media_type,media_url,caption,thumbnail_url, permalink',
    },
  },
];
